import dayjs from 'dayjs'


export const hardwareType = [
  {
    label:'S1',
    value:'s1'
  },
  {
    label:'S2',
    value:'s2'
  },
  {
    label:'H2',
    value:'h2'
  },
  {
    label:'MT PAD-linux',
    value:'mtpad_linux'
  },
  {
    label:'MT PAD-android',
    value:'mtpad_android'
  },
]

export function displayHardwareType(v){
  const obj = hardwareType.find(item => item.value === v);
  if(obj){
    return obj.label
  }
  return 'S1'
}

/*网关列表*/
export const columns = [
  {
    title: 'actions',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: 80,
    ellipsis: true
  },
  {
    title: 'process_flow_card_no',
    dataIndex: 'code',
    width: 200,
    scopedSlots: { customRender: 'gatewayCodeRender' },
    ellipsis: true
  },
  {
    title: 'page_bingding_device',
    dataIndex: 'associateWorkStations',
    width: 150,
    ellipsis: true
  },
  {
    title: 'page_last_online',
    dataIndex: 'lastOnlineTime',
    width: 150,
    ellipsis: true,
    customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
  },
  {
    title: 'page_last_offline',
    dataIndex: 'lastOfflineTime',
    width: 150,
    ellipsis: true,
    customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
  },
  {
    title: 'page_getwat_list_describe',
    dataIndex: 'name',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' }
  }
]

export const columnsHost = [
  {
    title: 'actions',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: 80,
    ellipsis: true
  },
  {
    title: 'process_flow_card_no',
    dataIndex: 'code',
    width: 200,
    scopedSlots: { customRender: 'gatewayCodeRender' },
    ellipsis: true
  },
  {
    title: 'page_bingding_device',
    dataIndex: 'associateWorkStations',
    width: 150,
    ellipsis: true
  },
  {
    title: '硬件类型',
    dataIndex: 'hardwareType',
    key:'hardwareType',
    width: 150,
    ellipsis: true,
    customRender: (value) => {
      let obj = hardwareType.find(item => item.value === value)
      if (obj){
        return  obj.label
      }else {
        return ''
      }
    },
    // customCell: () => {
    //   return {
    //     style: {
    //       display: getLocalStorage('isHost') || false ? '' : "none",
    //
    //     }
    //   }
    // },
    // customHeaderCell:() => {
    //   return {
    //     style: {
    //       display: getLocalStorage('isHost') || false ? '' : "none",
    //     }
    //   }
    // }
  },
  /*  {
      title: '是否在线',
      key: 'isOnline',
      dataIndex: 'isOnline',
      scopedSlots: { customRender: 'isOnline' },
      width: 80,
      ellipsis: true
    },*/
  {
    title: 'page_last_online',
    dataIndex: 'lastOnlineTime',
    width: 150,
    ellipsis: true,
    customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
  },
  {
    title: 'page_last_offline',
    dataIndex: 'lastOfflineTime',
    width: 150,
    ellipsis: true,
    customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
  },
  /*  {
      title: '批次编号',
      dataIndex: 'batchNo',
      width: 120,
      ellipsis: true
    },*/
  {
    title: 'page_getwat_list_describe',
    dataIndex: 'name',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' }
  }
]

/*应用列表*/
export const appListColumns = [
  {
    title: 'App ID',
    dataIndex: 'code',
    key: 'code',
    width: 50,
    ellipsis: true
  },
  {
    title: 'page_workstation_maintain_app_name',
    dataIndex: 'name',
    key: 'name',
    width: 130,
    ellipsis: true
  },
  {
    title: '驱动',
    dataIndex: 'description',
    key: 'description',
    width: 130,
    ellipsis: true,
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'page_workstation_maintain_isOnline',
    key: 'isOnline',
    dataIndex: 'isOnline',
    scopedSlots: { customRender: 'isOnline' },
    width: 80,
    ellipsis: true
  },
  /*{
    title: '是否监听',
    key: 'logMonitoring',
    dataIndex: 'logMonitoring',
    scopedSlots: { customRender: 'logMonitoring' },
    width: 100,
    ellipsis: true
  }*/
]

/*网关、应用在线状态*/
export const statusList = [
  {
    label: 'online',
    value: 1
  }, {
    label: 'offline',
    value: 0
  }
]

/*应用设置类型列表*/
export const dataTypes = {
  0: 'VOID',
  1: 'BIT',
  2: 'UINT8',
  3: 'UINT16',
  4: 'UINT32',
  5: 'UINT64',
  6: 'INT8',
  7: 'INT16',
  8: 'INT32',
  9: 'INT64',
  10: 'REAL4',
  11: 'REAL8',
  12: 'TIME',
  20: 'STRING',
  21: 'ALARM',
  65: 'BITARRAY',
  66: 'UINT8ARRAY',
  67: 'UINT16ARRAY',
  68: 'UINT32ARRAY',
  69: 'UINT64ARRAY',
  70: 'INT8ARRAY',
  71: 'INT16ARRAY',
  72: 'INT32ARRAY',
  73: 'INT64ARRAY',
  74: 'REAL4ARRAY',
  75: 'REAL8ARRAY',
  76: 'TIMEARRAY',
  84: 'STRINGARRAY',
  85: 'ALARMARRAY',
  192: 'AUTOARRAY',
}

/*类型列表对应的表单项类型*/
export const formTypes = {
  'numberInput': [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  'timePicker': [12],
  'input': [20],
  'switch': [1],
  'multiNumberInput': [66, 67, 68, 69, 70, 71, 72, 73, 74, 75],
  'multiTimePicker': [76],
  'multiSwitch': [65],
  'multiInput': [84]
}

/*应用设置列表*/
export const appSettingCols = [
  {
    title: 'process_flow_card_no',
    dataIndex: 'code',
    key: 'code',
    width: 80,
    ellipsis: true
  }, {
    title: 'page_getwat_list_arrt_name',
    dataIndex: 'name',
    key: 'name',
    width: 120,
    ellipsis: true
  }, {
    title: 'page_extranet_Type',
    dataIndex: 'dataType',
    key: 'dataType',
    width: 100,
    ellipsis: true,
    customRender: (text) => text ? (dataTypes[text]?.toLowerCase() ? dataTypes[text].toLowerCase() : '') : '',
  }, {
    title: 'page_getwat_list_default_value',
    dataIndex: 'defaultValue',
    key: 'defaultValue',
    width: 100,
    ellipsis: true
  }, {
    title: 'page_getwat_list_new_value',
    dataIndex: 'currentValue',
    key: 'currentValue',
    width: 120,
    ellipsis: true
  }, {
    title: 'page_getwat_list_expected_value',
    dataIndex: 'expectedValue',
    key: 'expectedValue',
    width: 120,
    ellipsis: true
  }
]

/*应用方法列表*/
export const columnsMethod = [
  {
    title: 'actions',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: 80,
    ellipsis: true
  },
  {
    title: 'process_flow_card_no',
    dataIndex: 'code',
    width: 80,
    ellipsis: true
  },
  {
    title: 'page_getwat_list_arrt_name',
    key: 'name',
    dataIndex: 'name',
    width: 120,
    ellipsis: true
  },
  {
    title: 'page_getwat_list_return_type',
    dataIndex: 'returnType',
    customRender: (text) => text ? (dataTypes[text]?.toLowerCase() ? dataTypes[text].toLowerCase() : '') : '',
    width: 120,
    ellipsis: true
  },
  {
    title: 'page_getwat_list_describe',
    dataIndex: 'description',
    width: 120,
    ellipsis: true
  }
]

/*应用事件列表*/
export const columnsEvent = [
  {
    title: 'process_flow_card_no',
    dataIndex: 'code',
    width: 80,
    ellipsis: true
  },
  {
    title: 'page_getwat_list_arrt_name',
    key: 'name',
    dataIndex: 'name',
    width: 150,
    ellipsis: true
  },
  {
    title: 'page_getwat_list_last_report_time',
    dataIndex: 'lastReportTime',
    width: 150,
    ellipsis: true,
    customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
  },
  {
    title: 'page_getwat_list_last_report_information',
    dataIndex: 'lastReportContent',
    width: 150,
    ellipsis: true
  }
]

export const isTakeEffected = ['page_getwat_list_not_submitted','page_getwat_list_to_be_updated','page_getwat_list_effective','page_getwat_list_not_effective']

/*属性列表*/
export const columnsQuality = [
  {
    title: 'actions',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: 180
  },
  {
    title: 'process_flow_card_no',
    dataIndex: 'code',
    width: 60,
    ellipsis: true
  },
  {
    title: 'page_getwat_list_arrt_name',
    dataIndex: 'name',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'page_getwat_list_arrt_address',
    dataIndex: 'ioAddress',
    width: 150,
    ellipsis: true
    // scopedSlots: { customRender: 'ioAddress' },
  },
  {
    title: 'page_getwat_list_data_type',
    dataIndex: 'type',
    width: 100,
    ellipsis: true,
    customRender: (text) => text ? (dataTypes[text]?.toLowerCase() ? dataTypes[text].toLowerCase() : '') : '',  },
  {
    title: 'page_getwat_list_new_value',
    dataIndex: 'currentValue',
    width: 180,
    ellipsis: true,
    scopedSlots: { customRender: 'currentValue' },
  },
  {
    title: 'page_workstation_maintain_default_value1',
    dataIndex: 'defaultValue',
    width: 110,
    ellipsis: true
    // scopedSlots: { customRender: 'defaultValue' },
  },
  {
    title: 'page_workstation_maintain_isTakeEffected',
    dataIndex: 'isTakeEffected',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'isTakeEffected' },
  },
  {
    title: 'page_getwat_list_magnification',
    dataIndex: 'factor',
    width: 80,
    ellipsis: true
    // scopedSlots: { customRender: 'factor' },
  },
  {
    title: 'page_getwat_list_describe',
    dataIndex: 'description',
    ellipsis: true
  }
]
/*实时数据*/
export const columnsRealtime = [
  {
    title: 'page_getwat_list_arrt_name',
    dataIndex: 'propertyName',
    width: 300,
    ellipsis: true
  },
  {
    title: 'value',
    dataIndex: 'propertyValue',
    width: 300,
    ellipsis: true,
  },
  {
    title: 'page_transport_directory_upload_time',
    dataIndex: 'reportTime',
    width: 300,
    ellipsis: true,
    customRender: (time) => !time || time === "-" ? "-" : dayjs(time).format('YYYY-MM-DD HH:mm:ss')
  }
]

/*通信历史*/
export const columnsHistory = [
  {
    title: 'actions',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: 100,
    ellipsis: true
  },
  {
    title: 'page_getwat_list_message_type',
    dataIndex: 'messageType',
    width: 100,
    ellipsis: true,
    // scopedSlots: { customRender: 'messageType' }
  },
  {
    title: 'page_getwat_list_communication_time',
    dataIndex: 'messageTime',
    width: 150,
    ellipsis: true,
    customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
  },
  {
    title: 'page_getwat_list_communication_information',
    dataIndex: 'message',
    width: 150,
    ellipsis: true
  }
]

/* 历史数据表格 */
export const historyTableColumns = [
  {
    title: 'page_getwat_list_collection_item',
    dataIndex: 'propertyName',
    ellipsis: true
  },
  {
    title: 'page_getwat_list_acquisition_time',
    dataIndex: 'ts',
    ellipsis: true,
    customRender: (time) => !time || time === "-" ? "-" : dayjs(time).format('YYYY-MM-DD HH:mm:ss')
  },
  {
    title: 'page_getwat_list_acquisition_value',
    dataIndex: 'propertyValue',
    ellipsis: true,
  },
  {
    title: 'page_getwat_list_data_status',
    dataIndex: 'dataStatus',
    ellipsis: true,
  }
]
/* 历史数据表格 */
